import request from "root/js/request";

export const getRefundsAndTransfersTopProduct = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  category_id__in,
  brand_id__in,
  supplier_article__in,
  barcode__in,
  subject_id__in,
  product_id__in,
  value,
  delivery,
  ...rest
}) => {
  const response = await request({
    url: "analytics/ride_returns_top_products/",

    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      supplier_article__in,
      barcode__in,
      subject_id__in,
      product_id__in,
      value,
      delivery,
      ...rest,
    },
  });
  return response.data;
};
